
  document.addEventListener('DOMContentLoaded', function() {
    // Filter chips + nav category links
    var bar = document.getElementById('filterBar');

    function applyFilter(f) {
      // sync chip active state
      if (bar) {
        bar.querySelectorAll('.chip').forEach(function(c) {
          c.classList.toggle('active', c.dataset.filter === f);
        });
      }
      document.querySelectorAll('#booksGrid .book-card').forEach(function(card) {
        var s = card.dataset.status;
        var t = card.dataset.type;
        var show =
          f === 'all' ||
          (f === 'available' && s === 'available') ||
          (f === 'coming' && s === 'coming') ||
          (f === 'plushies' && t === 'plushies');
        card.style.display = show ? '' : 'none';
      });
    }

    if (bar) {
      bar.addEventListener('click', function(e) {
        var btn = e.target.closest('.chip');
        if (!btn) return;
        applyFilter(btn.dataset.filter);
      });
    }

    // Top-nav category links
    document.querySelectorAll('a[data-filter-link]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var f = a.dataset.filterLink;
        applyFilter(f);
        // let the default scroll-to-#catalog still happen
      });
    });
  });

  
